import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Twitter, Facebook } from 'lucide-react';

const LOGO = "https://static.prod-images.emergentagent.com/jobs/6554b71a-e92e-45d6-a2ea-28b8d837c5dd/images/05ed22a83a162dbd4a68bdfa54453a7a8a9f16d8e3a633061831e14ecf8e4761.jpeg";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-navy-dark text-white noise-overlay relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src={LOGO} alt="HYGAD" className="h-12 w-auto mb-6" />
            <p className="text-white/60 text-sm leading-relaxed max-w-sm mb-6">
              HYGAD is the regional hospitality marketplace for Andhra Pradesh and Telangana — connecting travelers and event planners with the region's finest stays and celebration venues.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-gold/20 flex items-center justify-center transition-colors duration-200" aria-label="Instagram">
                <Instagram size={16} />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-gold/20 flex items-center justify-center transition-colors duration-200" aria-label="Twitter">
                <Twitter size={16} />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-gold/20 flex items-center justify-center transition-colors duration-200" aria-label="Facebook">
                <Facebook size={16} />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold font-medium mb-5">Explore</h4>
            <ul className="space-y-3">
              {[
                { label: 'Stays', to: '/search?experience=stay' },
                { label: 'Celebrations', to: '/search?experience=celebrate' },
                { label: 'Hyderabad', to: '/search?city=Hyderabad' },
                { label: 'Vijayawada', to: '/search?city=Vijayawada' },
                { label: 'Visakhapatnam', to: '/search?city=Visakhapatnam' },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners & Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold font-medium mb-5">For Partners</h4>
            <ul className="space-y-3 mb-8">
              {[
                { label: 'List Your Property', to: '/auth?tab=partner' },
                { label: 'Partner Dashboard', to: '/partner' },
                { label: 'Onboarding Fees', to: '/#pricing' },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-white/50 text-xs">
                <Mail size={13} />
                <span>hello@hygad.in</span>
              </div>
              <div className="flex items-center gap-2 text-white/50 text-xs">
                <MapPin size={13} />
                <span>Hyderabad, Telangana</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} HYGAD. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-white/40 text-xs hover:text-white/70 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-white/40 text-xs hover:text-white/70 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
